import { type } from '@/utils/type'


export const UNITEMOBILE_REQUEST = type('UNITEMOBILE_REQUEST')
export const UNITEMOBILE_SUCCESS = type('UNITEMOBILE_SUCCESS')
export const UNITEMOBILE_ERROR = type('UNITEMOBILE_ERROR')

export const UNITEMOBILE_ENSURE_LIST = type('UNITEMOBILE_ENSURE_LIST')

export const UNITEMOBILE_SELECT_DETAIL_REQUEST = type('UNITEMOBILE_SELECT_DETAIL_REQUEST')
export const UNITEMOBILE_SELECT_DETAIL_SUCCESS = type('UNITEMOBILE_SELECT_DETAIL_SUCCESS')
export const UNITEMOBILE_SELECT_DETAIL_ERROR = type('UNITEMOBILE_SELECT_DETAIL_ERROR')
export const UNITEMOBILE_SELECT_DETAIL = type('UNITEMOBILE_SELECT_DETAIL')

export const UNITEMOBILE_SAVE_REQUEST = type('UNITEMOBILE_SAVE_REQUEST')
export const UNITEMOBILE_SAVE_SUCCESS = type('UNITEMOBILE_SAVE_SUCCESS')
export const UNITEMOBILE_SAVE_ERROR = type('UNITEMOBILE_SAVE_ERROR')

export const UNITEMOBILE_UPDATE_MODIFIED_ADM = type('UNITEMOBILE_UPDATE_MODIFIED_ADM')
export const UNITEMOBILE_CANCEL_MODIFIED_ADM = type('UNITEMOBILE_CANCEL_MODIFIED_ADM')

export const UNITEMOBILE_UPDATE_FILTER_ADM = type('UNITEMOBILE_UPDATE_FILTER_ADM')